import {
	CLOSE_CONNECTION,
	OPEN_CONNECTION,
	SEND_FILES,
	SET_AVAILABILITY,
	SEND_DASHBOARD,
	CLOSE_DASHBOARD,
	SEND_PATIENT
} from 'actions/dualScreen';

export function openDualScreen(presentationConnection) {
	return {
		type: OPEN_CONNECTION,
		payload: presentationConnection,
	};
}

export function closeDualScreen() {
	return {
		type: CLOSE_CONNECTION,
	};
}

export function sendFilesToDualScreen(files) {
	return {
		type: SEND_FILES,
		payload: files,
	};
}

export function sendDashboardToDualScreen(stats) {
	return {
		type: SEND_DASHBOARD,
		payload: stats
	};
}
export function stopDashboardToDualScreen() {
	return {
		type: SEND_DASHBOARD,
		payload: null
	};
}

export function closeDashboardToDualScreen() {
	return {
		type: CLOSE_DASHBOARD,
	};
}

export function setDualScreenAvailability(available) {
	return {
		type: SET_AVAILABILITY,
		payload: available,
	};
}
export function sendPatientToDualScreen(patient) {
	return {
		type: SEND_PATIENT,
		payload: patient
	};
}
